/* eslint-disable import/prefer-default-export */

import { CALL_API } from 'redux-api-middleware';
import {
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAILURE
} from '../constants';

export default formState => {
  const formData = new FormData();
  const {
    username,
    password,
    firstName,
    lastName,
    gender,
    phone,
    address,
    billing_address,
    kidsCount,
    kidsAges,
    file
  } = formState;

  if (file) {
    formData.append('file', file, file.name);
  }

  formData.append('username', username);
  formData.append('password', password);
  formData.append('firstName', firstName);
  formData.append('lastName', lastName);
  formData.append('gender', gender);
  formData.append('phone', phone);
  formData.append('address', address);
  formData.append('billing_address', billing_address);
  formData.append('kidsCount', kidsCount);
  formData.append('kidsAges', JSON.stringify(kidsAges));
  return {
    [CALL_API]: {
      endpoint: '/register',
      method: 'POST',
      body: formData,
      credentials: 'include',
      types: [
        USER_REGISTER_REQUEST,
        USER_REGISTER_SUCCESS,
        USER_REGISTER_FAILURE
      ]
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/register.js